import { z } from 'zod'
import { tenantRoleSchema } from '../enums/tenant-role.enum.js'
import { emailSchema } from '../validators/email.validator.js'

export const inviteMemberInputSchema = z
  .object({
    email: emailSchema,
    role: tenantRoleSchema,
  })
  .strict()

export type InviteMemberInput = z.infer<typeof inviteMemberInputSchema>

export const changeMemberRoleInputSchema = z
  .object({ role: tenantRoleSchema })
  .strict()

export type ChangeMemberRoleInput = z.infer<typeof changeMemberRoleInputSchema>
